import { NotifyHelper } from "../../../helpers/toast";
import { eEmailPhuHuynhActionTypeDefine } from "../../action-types/don-hang/IEmailPhuHuynhActions";
import { generateActions, generateActionForKey } from "../generateActions";

export const emailPhuHuynhActions = {
    ...generateActions(eEmailPhuHuynhActionTypeDefine, "EMAIL_PHU_HUYNH"),
    ...generateActionForKey(eEmailPhuHuynhActionTypeDefine, "EMAIL_PHU_HUYNH", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
};
